import { render, staticRenderFns } from "./JiraStyleTimePeriod.vue?vue&type=template&id=2de27f6d&"
import script from "./JiraStyleTimePeriod.vue?vue&type=script&lang=js&"
export * from "./JiraStyleTimePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de27f6d')) {
      api.createRecord('2de27f6d', component.options)
    } else {
      api.reload('2de27f6d', component.options)
    }
    module.hot.accept("./JiraStyleTimePeriod.vue?vue&type=template&id=2de27f6d&", function () {
      api.rerender('2de27f6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Inputs/JiraStyleTimePeriod.vue"
export default component.exports